/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBell: {
  name: 'bell';
  data: string;
} = {
  name: 'bell',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2a7 7 0 0 0-7 7v4.697l-.795 1.194C3.318 16.22 4.27 18 5.869 18H8a4 4 0 0 0 8 0h2.132c1.597 0 2.55-1.78 1.664-3.11L19 13.698V9a7 7 0 0 0-7-7Zm2 16h-4a2 2 0 1 0 4 0ZM7 9a5 5 0 0 1 10 0v4.697a2 2 0 0 0 .336 1.11L18.132 16H5.869l.795-1.193A2 2 0 0 0 7 13.697V9Z" fill="currentColor"/></svg>`,
};
